(function () {
    'use strict';
    angular.module('SMART2').factory('lookup', ['$rootScope', function ($rootScope) {
        var Obj = {};
        Obj.onCallback = undefined;
        Obj.on = function (callback) {
            Obj.onCallback = callback;
        };

        Obj.open = function (config, callback) {
            this.config = config;
            this.broadcastItem();
            this.resultCallBack = function (result) {
                callback(result);
            };
        };
        Obj.optionUpdate = function (option) {
            if (typeof this.config != 'undefined') {
                this.config.config.options = option;
            }
        };
        Obj.getConfig = function () {
            return this.config;
        };
        Obj.onScrollEnd = function (callback) {
            this.onScrollEndCall = function () {
                callback();
            };
        };
        Obj.onScrollTop = function (callback) {
            this.onScrollTopCall = function () {
                callback();
            };
        };
        Obj.onScrollInProgress = function (callback) {
            this.onScrollInProgressCall = function () {
                callback();
            };
        };
        Obj.broadcastItem = function () {
            angular.isFunction(Obj.onCallback) && Obj.onCallback();
        };
        return Obj;
    }]);

    var countForTheProprty = 0;
    angular.module('SMART2').directive('smartLookup', ['$rootScope', '$timeout', '$translate', 'ScrollTo', 'lookup', function ($rootScope, $timeout, $translate, ScrollTo, lookup) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@'
            },
            link: function (scope, element, attrs) {
                scope.lookupLoaderConfig = {
                    plain: true,
                    center: true,
                    message: "Loading..."
                };

                function isObjectEquals(obj1, obj2) {
                    var checkObj2 = function () {
                        for (var i in obj2) { }
                        return i == undefined ? false : true;
                    }
                    if (obj2 == '' || obj2 == null || checkObj2() === false) {
                        return false;
                    }
                    for (var i in obj2) {
                        if (obj2.hasOwnProperty(i)) {
                            if (!obj1.hasOwnProperty(i)) return false;
                            if (obj2[i] != obj1[i]) return false;
                        }
                    }
                    return true;
                }
                function containsObject(obj, list, catalogObj) {
                    for (var i = 0; i < list.length; i++) {
                        if (catalogObj) {
                            if (obj.UserId == list[i]) {
                                return true;
                            };
                        } else {
                            if (isObjectEquals(obj, list[i])) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
                scope.smartScrollEnd = function () {
                    if (angular.isFunction(lookup.onScrollEndCall)) {
                        lookup.onScrollEndCall();
                    };
                    $timeout(function () {
                        if (scope.isLazyLoadingEnabled && scope.limitToCount <= scope.options.length)
                            scope.limitToCount = scope.limitToCount + 35;
                    });
                };
                scope.smartScrollTop = function () {
                    if (angular.isFunction(lookup.onScrollTopCall)) {
                        lookup.onScrollTopCall();
                    };
                };
                scope.smartScrollInProgress = function () {
                    if (angular.isFunction(lookup.onScrollInProgressCall)) {
                        lookup.onScrollInProgressCall();
                    };
                };
                scope.searchText = { title: "" };
                scope.selectdCount = 0;
                scope.model = [];
                scope.options = [];
                scope.displayProperties = ["name"];
                scope.selectTypeOptionWith = '';
                scope.propKey = "";
                countForTheProprty++;
                function generateName(obj) {
                    var label = "";
                    if (scope.displayProperties.length == 1) {
                        label = obj[scope.displayProperties[0]];
                    }
                    else {
                        for (var j = 0; j < scope.displayProperties.length; j++) {
                            if (scope.propSeparation !== undefined && j !== scope.displayProperties.length - 1) {
                               label = label + " " + obj[scope.displayProperties[j]] + " " + scope.propSeparation;
                            }
                            else { 
                                label = label + " " + obj[scope.displayProperties[j]];
                            }
                        }
                    }
                    return label;
                }
                var stopInit = false;
                function initialize() {
                    //migrate two array with flag
                    scope.propKey = "counterProp" + countForTheProprty;
                    if (scope.options == undefined || scope.config.options == undefined) {
                        scope.options = [];
                    } else {                      
                            scope.options = scope.config.options;                        
                    }
                    if (scope.multiple) {
                        for (var i = 0; i < scope.options.length; i++) {
                            if (!scope.options[i].hasOwnProperty("ischecked") && !stopInit) {
                                if (containsObject(scope.options[i], scope.model, scope.isObjectCompareCatalog)) {
                                    scope.options[i].ischecked = true;
                                    scope.options[i][scope.propKey] = generateName(scope.options[i]);
                                } else {
                                    scope.options[i].ischecked = false;
                                    scope.options[i][scope.propKey] = generateName(scope.options[i]);
                                }
                                }
                            }                           
                        if (scope.minMultiselect) {
                            checkSelectedItems();
                        }
                    } else {
                        for (var i = 0; i < scope.options.length; i++) {
                            if (!stopInit) {
                                if (isObjectEquals(scope.options[i], scope.model)) {
                                    scope.options[i].ischecked = true;
                                    scope.options[i][scope.propKey] = generateName(scope.options[i]);
                                } else {
                                    scope.options[i].ischecked = false;
                                    scope.options[i][scope.propKey] = generateName(scope.options[i]);
                                }
                                }
                            }
                    }
                    scope.limitToCount = scope.isLazyLoadingEnabled ? 35 : scope.options.length;
                };
                function setLoader(e) {
                    if (e.target.value.trim() != "") {
                        scope.showLoader = true;
                        scope.showSearchLoader = true;
                    }

                    if (scope.config.options.length == 0) {
                        scope.showLoader = false;
                    }

                    element.find("#lookup-content-wrpper .scroll-content").scrollTop(0);
                    if (scope.clearModelOnEnter) {
                        scope.model = [];
                    }
                }
                scope.searchTextKeyUpFn = function (e) {
                    if (scope.config.onKeyUp) {
                        scope.config.onKeyUp({ $data: { text: e.target.value, type: "textfield", "e": e } });
                    }
                    if (e.keyCode === 13 && (scope.stopFilterOnKey === "true" || scope.stopFilterOnKey === true) && (scope.requireLoader === "true" || scope.requireLoader === true)) {
                        if (scope.searchCount > 0 && e.target.value.length >= scope.searchCount) {
                            setLoader(e);
                        }
                        else if (typeof (scope.searchCount) === "undefined") {
                            setLoader(e);
                        }
                    }
                    scope.cancelTitle = e.target.value == "" ? $translate.instant('closeSearch') : $translate.instant('clearSearch'); 
                }

                var regEx = new RegExp("", "ig");
                function scrollbarReload() {
                    if (scope.scrollAlwaysTopOnload == true && scope.scrollReload == false) {
                        scope.scrollReload = true
                    } else if (scope.scrollAlwaysTopOnload == true && scope.scrollReload == true) {
                        scope.scrollReload = false
                    }
                };
                scope.triggerFlag = false;
                var returnObj = {};
                lookup.on(function () {
                    scope.config = lookup.config.config;
                    scope.minMultiselect = scope.config.minMultiselect;
                    scope.label = scope.config.label;
                    scope.lookupId = scope.config.id;
                    scope.isSearchOpen = false;
                    scope.multiple = false;
                    scope.addnew = false;
                    scope.readonly = false;
                    scope.multiple = typeof (scope.config.mutliselect) == "undefined" ? false : scope.config.mutliselect;
                    scope.addnew = typeof (scope.config.addnew) == "undefined" ? false : scope.config.addnew;
                    scope.readonly = typeof (scope.config.readonly) == "undefined" ? false : scope.config.readonly;
                    scope.titleOfModel = typeof (scope.config.titleOfModel) === "undefined" ? $translate.instant('titleOfModel') : scope.config.titleOfModel;
                	/*  Default Selection scope variable */
                    scope.config.defaultSelectOption = typeof (scope.config.defaultSelectOption) === "undefined" ? false : scope.config.defaultSelectOption;
                    scope.config.defaultSelectionText = typeof (scope.config.defaultSelectionText) === "undefined" ? "" : scope.config.defaultSelectionText;
                    scope.config.selectTypeOption = typeof (scope.config.selectTypeOption) === "undefined" ? null : scope.config.selectTypeOption;
                    scope.selectiontext = angular.copy(scope.config.selectTypeOption);    
                    scope.model = lookup.config.modelData;
                    scope.isLazyLoadingEnabled = scope.config.isLazyLoadingEnabled;
                    if (angular.isDefined(scope.model) && scope.model != null) {
                        scope.selectdCount = scope.model.length;
                    } else {
                        scope.selectdCount = 0;
                    }
                    scope.options = typeof (scope.config.options) == "undefined" ? [] : scope.config.options;
                    scope.limitToCount = scope.isLazyLoadingEnabled ? 35 : scope.options.length;
                    scope.displayProperties = scope.config.displayProperties.length > 0 ? scope.config.displayProperties : scope.displayProperties;
                    scope.propSeparation = scope.config.propSeparation;
                    scope.scrollAlwaysTopOnload = (scope.config.scrollAlwaysTopOnload === undefined) ? false : scope.config.scrollAlwaysTopOnload;
                    scope.scrollReload = scope.scrollAlwaysTopOnload ? false : true;
                    scope.selectTypeOptionWith = scope.config.selectTypeOptionWith ? scope.config.selectTypeOptionWith : scope.selectTypeOptionWith;
                    scope.searchFilterKey = scope.config.searchFilterKey; // added for filter on key basis
                    scope.stopFilterOnKey = scope.config.stopFilterOnKey; // added for stop filtering on keydown
                    scope.searchCount = scope.config.searchCount;
                    scope.requireLoader = scope.config.requireLoader;
                    if (scope.requireLoader == "true") {
                        scope.showLoader = true;
                    }
                    scope.hideSelectedCount = scope.config.hideSelectedCount;
                    scope.isObjectCompareCatalog = scope.config.isObjectCompareCatalog;
                    scope.clearModelOnEnter = scope.config.clearModelOnEnter;
                    initialize();
                    scope.triggerFlag = true;
                    scrollbarReload();
                    $timeout(function () {
                    element.find('.lookupPopupContent input[checked="checked"]').prop('checked', true);            
                });
                    scope.$watch(function () {
                        return lookup.config.config.options;
                    },
                    function (newVal, oldVal) {
                        initialize();
                        if (newVal.length > 0) {
                            scope.showLoader = false;
                        }

                        if (newVal.length == 0 && scope.showSearchLoader == true) {
                            scope.showLoader = false;
                            scope.showSearchLoader = false;
                        }
                    }, true);
                    returnObj.addnew = false;
                    returnObj.result = scope.model;
                    returnObj.btnType = '';
                    returnObj.defaultSelectionText = scope.config.defaultSelectionText.trim(),
                    returnObj.selectTypeOption = scope.config.selectTypeOption;
                    returnObj.errorModel = scope.config.errorModel;
                    scope.defaultError = false;

                    if (scope.selectdCount == 0 && scope.$eval(scope.config.isMandatory))
                    	scope.itemSelected = false;
                    else
                        scope.itemSelected = true;

                    scope.isLimitmultiselect = scope.minMultiselect ? scope.minMultiselect.event : false; scope.minMultiselect

                });

                scope.searchToggle = function () {
                    if (scope.isSearchOpen == false) {
                        scope.isSearchOpen = true;
                        $timeout(function () {
                            $("#searchTextbox").find("input").focus();
                        });
                    }
                    if (scope.config.onKeyUp) {
                        scope.config.onKeyUp({ $data: { text: scope.searchText.title, type: "search" } });
                    }
                    scope.cancelTitle = scope.searchText.title == "" ? $translate.instant('closeSearch') : $translate.instant('clearSearch');
                };
                scope.closeSearch = function () {
                    if (scope.searchText.title != "") {
                        scope.searchText.title = "";
                    } else {
                        scope.isSearchOpen = false;
                        $("#btnShowSearch").focus();
                    }
                    if (scope.config.onKeyUp) {
                        scope.config.onKeyUp({ $data: {text: scope.searchText.title, type : "close" } });
                    }
                    scope.cancelTitle = scope.searchText.title == "" ? $translate.instant('closeSearch') : $translate.instant('clearSearch');
                };

            	/*  triggers which default radio btn click */
                scope.ondefaultSelectItem = function (obj) {
                	obj.ischecked = true;
                	scope.onChangeItem(obj);
                	scope.defaultError = false;
                	scope.config.errorModel = '';
                };
                var checkSelectedItems = function () {
                    if (scope.selectdCount >= parseInt(scope.minMultiselect.value)) {
                        for (var i = 0; i < scope.options.length; i++) {
                            if (!scope.options[i].ischecked) {
                                scope.options[i].isdisable = true;
                            } else {
                                scope.options[i].isdisable = false;
                            }
                        }
                    } else {
                        for (var i = 0; i < scope.options.length; i++) {
                            scope.options[i].isdisable = false;
                        }
                    }
                }
                scope.optionUnSelected = [];
                scope.onChangeItem = function (obj) {
                    if (scope.multiple) {
                		if (obj.ischecked) {
                			scope.selectdCount++;
                		} else {
                		    scope.selectdCount--;
                		    scope.optionUnSelected.push(obj);

                		    if (scope.$eval(scope.config.isDefaultMandatory) && obj[scope.propKey] === scope.config.defaultSelectionText) {
                		        scope.config.defaultSelectionText = ''
                		    }
                		}
                		if (scope.selectdCount == 0 && scope.$eval(scope.config.isMandatory)) {
                			scope.itemSelected = false;
                			scope.config.errorModel = $translate.instant("selectValueErrMsg");
                		}
                		else {
                			scope.itemSelected = true;
                			scope.config.errorModel = '';
                		}
                		if (scope.minMultiselect.event) {
                		    checkSelectedItems();
                		}
                	} else {
                		scope.model = obj;
                		scope.itemSelected = true;
                		scope.config.errorModel = '';
                		initialize();
                	}
                };
                
                function cleanData() {
                	stopInit = true;
                	for (var i = 0; i < scope.options.length; i++) {
                		delete scope.options[i].ischecked;
                		delete scope.options[i][scope.propKey];
                	}
                	$timeout(function () {
                		stopInit = false;
                	}, 500);
                };
                scope.defaultError = false;

                scope.cancelButton = { title: $translate.instant("cancelBtn") };
                scope.doneButton = { title: $translate.instant("doneBtn") };

                scope.selectionCancel = function () {
                    returnObj.btnType = 'cancel';
                }
                scope.selectionDone = function () {
                    returnObj.UnSelectedResult = [];
                	if (!scope.itemSelected && scope.$eval(scope.config.isMandatory)) {
                		return;
                	}
                	if (scope.$eval(scope.config.isDefaultMandatory) && scope.config.defaultSelectionText == '') {
                		scope.defaultError = true;
                		scope.config.errorModel = $translate.instant("markPaymentErrMsg");
                		return;
                	}
                    if (scope.multiple) {
                        var result = [];
                        stopInit = true;
                        for (var i = 0; i < scope.options.length; i++) {
                            delete scope.options[i][scope.propKey];
                            if (scope.options[i].ischecked) {
                            	delete scope.options[i].ischecked;

                            	/*  Default Selection check point */
                                if (scope.config.defaultSelectionText.trim() === scope.options[i].name) {
                                	result.unshift(scope.options[i]);
                                } else {
                                	result.push(scope.options[i]);
                                }
                            }
                        }
                        cleanData();
                        $timeout(function () {
                            stopInit = false;
                        }, 500);
                    }
                    else {
                        stopInit = true;
                        delete scope.model.ischecked;
                        delete scope.model[scope.propKey];
                        result = scope.model;
                        if (scope.config.selectTypeOption != null) {
                            scope.config.selectTypeOption.selectiontext = scope.selectiontext.selectiontext;
                        }
                        cleanData();
                        $timeout(function () {
                            stopInit = false;
                        }, 500)
                    }

                    returnObj.result = result;
                    returnObj.UnSelectedResult = scope.optionUnSelected;
                    scope.optionUnSelected = [];

                    returnObj.btnType = 'save';
                    returnObj.defaultSelectionText = scope.config.defaultSelectionText.trim();
                    returnObj.selectTypeOption = scope.config.selectTypeOption;
                    returnObj.errorModel = scope.config.errorModel;
                    scope.callbackOnHide();
                }
                scope.addNew = function () {
                    cleanData();
                    returnObj.addnew = true;
                    scope.triggerFlag = false;
                    scrollbarReload();
                }

                //Popup hide/show flag
                scope.callbackOnHide = function (e) {
                    scope.triggerFlag = false;
                    scrollbarReload();
                    scope.searchText.title = "";
                    if (scope.isLazyLoadingEnabled)
                    scope.limitToCount = 35;
                    scope.isSearchOpen = false;
                    //cleanData() comment this and add in manually due to avoid timeout checkbox issue;
                    stopInit = true;
                    for (var i = 0; i < scope.options.length; i++) {
                        delete scope.options[i].ischecked;
                        delete scope.options[i][scope.propKey];
                    }
                    $timeout(function () {
                        stopInit = false;
                    });

                    /*  Return Default Selection Object */
                    lookup.resultCallBack(returnObj);
                }
            },
            templateUrl: 'shared/directives/uiElements/smartLookup/smartLookupTemplate.html'
        };
    }]);
})();